/**
 * Endpoint paths of the domain. They are relative so axios appends them to the baseURL.
 *
 * The trailing slash is not cosmetic: the backend redirects a path without it, and a redirected
 * POST reaches the destination with no body at all.
 */
export const AUTH_ENDPOINTS = {
  LINK_CONSUME: 'v1/auth/link/consume/',
  STATUS: 'v1/auth/status/',
  PASSWORD: 'v1/auth/password/',
  PASSWORD_RECOVERY: 'v1/auth/password/recovery/',
  LINK_SEND: 'v1/auth/link/send/',
} as const;
